import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Popover } from "native-base";
import { isWeb } from "@madmedical/utils";
import IconButton from "../atoms/IconButton";
import Dropdown from "./Dropdown";
const ActionButton = ({ size = "sm", dropdownPosition = "bottom right", actions, iconName = "overflowMenuVertical", maxWidth = 44, }) => {
    const [isOpen, setIsOpen] = useState(false);
    if (!actions.length) {
        return null;
    }
    return (_jsx(Popover, Object.assign({ placement: dropdownPosition, trigger: (triggerProps) => (_jsx(IconButton, Object.assign({}, triggerProps, { alignSelf: "center", iconName: iconName, variant: "ghostLink", opacity: "60", size: size, onPress: () => (actions ? setIsOpen(true) : null), flex: 1 }))), isOpen: isOpen, onClose: () => setIsOpen((prevState) => !prevState) }, { children: _jsx(Popover.Content, Object.assign({ borderColor: "gray.100", bgColor: "transparent", overflow: "hidden", top: !isWeb ? -40 : 0 }, { children: _jsx(Dropdown, { maxWidth: maxWidth, list: actions, hasUI: false, triggerClose: () => setIsOpen(false) }) })) })));
};
export default ActionButton;
